// Extracted from app.module.ts so services that need the API suffix (e.g. AuthService,
// which is itself a dependency of app.module.ts's JwtModule.forRoot() config) don't have
// to import app.module.ts. Importing app.module.ts from a service that app.module.ts also
// depends on creates a circular import, which under Karma's webpack test bundling triggers
// a "Cannot access 'AuthService' before initialization" ReferenceError at module-eval time.
export const API_SUFFIX = '/api/v16';
